import { motion } from "framer-motion"

// Enter animation for view content: a short opacity fade only. The earlier 20px upward slide
// made every header and group in a view arrive from a different place, which read as the
// layout "jumping" together with the fullscreen switch.
const conf = {
  transition: { duration: .15, ease: 'easeOut' },
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 }
}

export function h3(props) { return <motion.h3 {...props} {...conf}></motion.h3> }
export function div({ type, ...props }) { return <motion.div {...props} {...conf}></motion.div> }
